module.exports = __webpack_public_path__ + "front/img/logo.e099812b.png";